export default __webpack_public_path__ + "static/media/environments-preview_dark.1266d095.jpg";